<app-page-breadcrumb pageTitle="Cotizaciones"></app-page-breadcrumb>

<div class="space-y-4">
  <!-- Controls Section -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <div class="flex items-center gap-1.5">
    </div>

    <div class="flex items-center gap-1.5">
      <button type="button" (click)="toggleFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z">
          </path>
        </svg>
        {{ showFilters ? 'Ocultar' : 'Filtros' }}
      </button>
      <button type="button" *appHasPermission="'quotes:create'" (click)="nuevaQuote()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        Nueva Cotización
      </button>
    </div>
  </div>

  <!-- Filters Panel -->
  @if (showFilters) {
  <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
      <!-- Search by quote number -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Número de Cotización
        </label>
        <input type="text" [(ngModel)]="filtroQuoteNumber" (ngModelChange)="buscar()" placeholder="QT-2026-000001"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
      </div>

      <!-- Filter by status -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Estado
        </label>
        <select [(ngModel)]="filtroStatusId" (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos</option>
          @for (status of quoteStatuses; track status.id) {
          <option [ngValue]="status.id">{{ status.name }}</option>
          }
        </select>
      </div>

      <!-- Filter by deal -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Negocio
        </label>
        <select [(ngModel)]="filtroDealId" (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todas</option>
          @for (deal of deals; track deal.id) {
          <option [ngValue]="deal.id">{{ deal.name }}</option>
          }
        </select>
      </div>

      <!-- Clear filters button -->
      <div class="flex items-end">
        <button type="button" (click)="limpiarFiltro()"
          class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700">
          Limpiar Filtros
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Métricas KPI (incidente #41) — sección discreta y colapsable; oculta si el rol no tiene permiso -->
  @if (!metricsHidden) {
  <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl">
    <button type="button" (click)="toggleMetrics()"
      class="w-full flex items-center justify-between px-4 py-2.5 group">
      <span class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide group-hover:text-gray-700 dark:group-hover:text-gray-300 transition-colors">
        Métricas de cotizaciones
      </span>
      <svg class="w-4 h-4 text-gray-400 transition-transform" [class.rotate-180]="!metricsCollapsed"
        fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
      </svg>
    </button>

    @if (!metricsCollapsed) {
    <div class="px-4 pb-4">
      @if (metricsLoading) {
      <!-- Skeleton -->
      <div class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-3">
        @for (s of [1,2,3,4,5]; track s) {
        <div class="rounded-lg border border-gray-100 dark:border-gray-800 p-3 animate-pulse">
          <div class="h-3 w-20 bg-gray-100 dark:bg-gray-800 rounded mb-3"></div>
          <div class="h-6 w-14 bg-gray-100 dark:bg-gray-800 rounded"></div>
        </div>
        }
      </div>
      } @else if (metrics) {
      <div class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-3">
        <!-- Total cotizaciones -->
        <div class="rounded-lg border border-gray-100 dark:border-gray-800 p-3">
          <p class="text-xs text-gray-500 dark:text-gray-400">Total cotizaciones</p>
          <p class="mt-1 text-2xl font-bold text-gray-900 dark:text-white">{{ metrics.totalQuotes }}</p>
          <p class="mt-0.5 text-xs text-gray-400 dark:text-gray-500">
            {{ metrics.acceptedCount }} aceptadas · {{ metrics.rejectedCount }} rechazadas
          </p>
        </div>

        <!-- Tasa de aceptación -->
        <div class="rounded-lg border border-gray-100 dark:border-gray-800 p-3">
          <p class="text-xs text-gray-500 dark:text-gray-400">Tasa de aceptación</p>
          <p class="mt-1 text-2xl font-bold text-success-600 dark:text-success-400">
            {{ metrics.acceptanceRatePct | number:'1.0-1' }}%
          </p>
          <p class="mt-0.5 text-xs text-gray-400 dark:text-gray-500">
            {{ metrics.avgVersionCount | number:'1.0-1' }} versiones prom.
          </p>
        </div>

        <!-- Monto cotizado vs ganado -->
        <div class="rounded-lg border border-gray-100 dark:border-gray-800 p-3">
          <p class="text-xs text-gray-500 dark:text-gray-400">Cotizado vs ganado</p>
          <p class="mt-1 text-xl font-bold text-gray-900 dark:text-white leading-tight">
            {{ formatMetricAmount(metrics.totalQuotedAmount) }}
          </p>
          <p class="mt-0.5 text-xs text-success-600 dark:text-success-400 font-medium">
            {{ formatMetricAmount(metrics.totalWonAmount) }} ganado
          </p>
        </div>

        <!-- Días promedio a cierre -->
        <div class="rounded-lg border border-gray-100 dark:border-gray-800 p-3">
          <p class="text-xs text-gray-500 dark:text-gray-400">Días prom. a cierre</p>
          <p class="mt-1 text-2xl font-bold text-gray-900 dark:text-white">
            {{ metrics.avgDaysToClose | number:'1.0-1' }}
          </p>
          <p class="mt-0.5 text-xs text-gray-400 dark:text-gray-500">desde emisión</p>
        </div>

        <!-- Por vencer en 7 días (resaltada en ámbar si > 0) -->
        <div class="rounded-lg border p-3"
          [class]="metrics.expiringIn7Days > 0
            ? 'border-amber-300 bg-amber-50 dark:border-amber-700/60 dark:bg-amber-900/15'
            : 'border-gray-100 dark:border-gray-800'">
          <p class="text-xs"
            [class]="metrics.expiringIn7Days > 0 ? 'text-amber-700 dark:text-amber-400 font-medium' : 'text-gray-500 dark:text-gray-400'">
            Por vencer en 7 días
          </p>
          <p class="mt-1 text-2xl font-bold flex items-center gap-1.5"
            [class]="metrics.expiringIn7Days > 0 ? 'text-amber-700 dark:text-amber-400' : 'text-gray-900 dark:text-white'">
            @if (metrics.expiringIn7Days > 0) {
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            }
            {{ metrics.expiringIn7Days }}
          </p>
          <p class="mt-0.5 text-xs"
            [class]="metrics.expiringIn7Days > 0 ? 'text-amber-600/80 dark:text-amber-500/80' : 'text-gray-400 dark:text-gray-500'">
            requieren seguimiento
          </p>
        </div>
      </div>
      }
    </div>
    }
  </div>
  }

  <!-- Bandeja del aprobador (RF-002): aprobaciones pendientes asignadas al usuario actual -->
  @if (pendingApprovals.length > 0) {
  <div class="bg-violet-50 dark:bg-violet-900/15 border border-violet-200 dark:border-violet-800 rounded-xl">
    <button type="button" (click)="toggleAprobaciones()"
      class="w-full flex items-center justify-between px-4 py-2.5 group">
      <span class="inline-flex items-center gap-2 text-sm font-medium text-violet-700 dark:text-violet-400">
        <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"/>
        </svg>
        @if (pendingApprovals.length === 1) {
        Tienes 1 aprobación pendiente
        } @else {
        Tienes {{ pendingApprovals.length }} aprobaciones pendientes
        }
      </span>
      <svg class="w-4 h-4 text-violet-400 transition-transform" [class.rotate-180]="approvalsExpanded"
        fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
      </svg>
    </button>

    @if (approvalsExpanded) {
    <div class="px-4 pb-4 overflow-x-auto custom-scrollbar">
      <table class="min-w-full">
        <thead>
          <tr class="border-b border-violet-200/70 dark:border-violet-800/60">
            <th class="px-3 py-2 font-medium text-violet-700/80 dark:text-violet-400/80 text-start text-theme-xs">Cotización</th>
            <th class="px-3 py-2 font-medium text-violet-700/80 dark:text-violet-400/80 text-start text-theme-xs">Negocio</th>
            <th class="px-3 py-2 font-medium text-violet-700/80 dark:text-violet-400/80 text-end text-theme-xs">Monto</th>
            <th class="px-3 py-2 font-medium text-violet-700/80 dark:text-violet-400/80 text-start text-theme-xs">Solicitante</th>
            <th class="px-3 py-2 font-medium text-violet-700/80 dark:text-violet-400/80 text-start text-theme-xs">Fecha</th>
            <th class="px-3 py-2 font-medium text-violet-700/80 dark:text-violet-400/80 text-start text-theme-xs">Comentario</th>
            <th class="px-3 py-2 font-medium text-violet-700/80 dark:text-violet-400/80 text-center text-theme-xs">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-violet-100 dark:divide-violet-900/40">
          @for (item of pendingApprovals; track item.id) {
          <tr>
            <td class="px-3 py-2.5 text-theme-sm whitespace-nowrap">
              <button type="button" (click)="verDetalleAprobacion(item)"
                class="font-medium text-brand-600 dark:text-brand-400 hover:underline"
                title="Ver detalle de la cotización">
                {{ item.quoteNumber }}
              </button>
              <span class="ml-1 text-xs text-gray-400 dark:text-gray-500">v{{ item.version }}</span>
            </td>
            <td class="px-3 py-2.5 text-theme-sm text-gray-600 dark:text-gray-400">
              <div class="flex flex-col">
                <span>{{ item.dealName || '—' }}</span>
                @if (item.companyName) {
                <span class="text-xs text-gray-400 dark:text-gray-500">{{ item.companyName }}</span>
                }
              </div>
            </td>
            <td class="px-3 py-2.5 text-theme-sm text-end font-medium text-gray-800 dark:text-white/90 whitespace-nowrap">
              {{ formatPendingAmount(item) }}
            </td>
            <td class="px-3 py-2.5 text-theme-sm text-gray-600 dark:text-gray-400 whitespace-nowrap">
              {{ item.requesterName }}
            </td>
            <td class="px-3 py-2.5 text-theme-sm text-gray-600 dark:text-gray-400 whitespace-nowrap">
              {{ formatDate(item.datetimeRequested) }}
            </td>
            <td class="px-3 py-2.5 text-theme-sm text-gray-600 dark:text-gray-400">
              @if (item.requestComment) {
              <span class="block max-w-[16rem] truncate italic" [title]="item.requestComment">"{{ item.requestComment }}"</span>
              } @else {
              —
              }
            </td>
            <td class="px-3 py-2.5 text-center whitespace-nowrap">
              <div class="flex items-center justify-center gap-1">
                <button type="button" (click)="abrirDecision(item, 'APPROVED')"
                  class="rounded-lg p-2 text-success-600 dark:text-success-400 hover:bg-success-50 dark:hover:bg-success-900/20 transition-colors"
                  title="Aprobar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                </button>
                <button type="button" (click)="abrirDecision(item, 'CHANGES_REQUESTED')"
                  class="rounded-lg p-2 text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors"
                  title="Solicitar cambios">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                  </svg>
                </button>
                <button type="button" (click)="abrirDecision(item, 'REJECTED')"
                  class="rounded-lg p-2 text-error-600 dark:text-error-400 hover:bg-error-50 dark:hover:bg-error-900/20 transition-colors"
                  title="Rechazar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </div>
  }

  <!-- Success -->
  @if (successMessage) {
  <div class="p-4 bg-success-50 border border-success-200 rounded-lg dark:bg-success-500/10 dark:border-success-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-success-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
      <p class="text-success-600 dark:text-success-400">{{ successMessage }}</p>
    </div>
  </div>
  }

  <!-- Loading -->
  @if (loading) {
  <div class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando cotizaciones...</span>
  </div>
  }

  <!-- Error -->
  @if (error) {
  <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  </div>
  }

  <!-- Quotes Table -->
  @if (!loading && !error) {
  <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="max-w-full overflow-x-auto custom-scrollbar">
      <table class="min-w-full">
        <!-- Table Header -->
        <thead class="border-b border-gray-100 dark:border-white/[0.05]">
          <tr>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Número</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Negocio</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Versión</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Total</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Vence</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Creada</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
          </tr>
        </thead>

        <!-- Table Body -->
        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
          @if (quotes.length === 0) {
          <tr>
            <td colspan="8" class="px-5 py-12 text-center">
              @if (hasActiveFilters) {
              <!-- Vacío por filtros -->
              <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                <svg class="w-12 h-12 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                    d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"/>
                </svg>
                <span class="font-medium">Sin resultados para los filtros</span>
                <span class="text-xs text-gray-400 dark:text-gray-500">Prueba ajustando o limpiando los filtros aplicados.</span>
                <button type="button" (click)="limpiarFiltro()"
                  class="mt-2 px-3 py-1.5 text-sm rounded-lg font-medium bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
                  Limpiar filtros
                </button>
              </div>
              } @else {
              <!-- Vacío real: aún no hay cotizaciones -->
              <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                <svg class="w-14 h-14 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                  </path>
                </svg>
                <span class="font-medium">Aún no hay cotizaciones</span>
                <span class="text-xs text-gray-400 dark:text-gray-500">Crea tu primera cotización para enviarla a un cliente.</span>
                <button type="button" *appHasPermission="'quotes:create'" (click)="nuevaQuote()"
                  class="mt-2 px-4 py-2 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 transition-colors flex items-center gap-1.5">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                  </svg>
                  Nueva Cotización
                </button>
              </div>
              }
            </td>
          </tr>
          }

          @for (quote of quotes; track quote.id) {
          <tr>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <div class="flex flex-col">
                <span class="font-medium text-gray-800 dark:text-white/90 inline-flex items-center gap-1.5">
                  {{ quote.quoteNumber }}
                  @if (quote.internalNotes) {
                  <svg class="w-3.5 h-3.5 text-amber-500 dark:text-amber-400 shrink-0"
                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <title>Notas internas: {{ quote.internalNotes.length > 140 ? quote.internalNotes.slice(0, 140) + '…' : quote.internalNotes }}</title>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"/>
                  </svg>
                  }
                </span>
                @if (quote.hasPublicLink) {
                <span class="text-xs text-teal-600 dark:text-teal-400" title="Tiene un enlace público activo">
                  Publicada con enlace
                </span>
                }
              </div>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              {{ getDealName(quote.dealId) }}
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <app-quote-status-badge [status]="quote.statusName"></app-quote-status-badge>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              v{{ quote.version }}
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="font-medium">{{ formatCurrency(quote.totalAmount, quote) }}</span>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="inline-flex items-center gap-1.5">
                {{ formatDate(getExpiresDate(quote)) }}
                @if (isExpiringSoon(quote)) {
                <!-- Vence dentro de 7 días -->
                <span class="inline-flex shrink-0" [title]="expiringTooltip(quote)" [attr.aria-label]="expiringTooltip(quote)">
                  <svg class="w-4 h-4 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </span>
                } @else if (isOverdue(quote)) {
                <!-- Ya venció y el estado aún no es Expirada -->
                <span class="inline-flex items-center gap-1 text-xs font-medium text-error-600 dark:text-error-400"
                  title="La fecha de validez ya pasó y el estado aún no es Expirada">
                  <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                  </svg>
                  Vencida
                </span>
                }
              </span>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              {{ formatDate(quote.datetimeCreated) }}
            </td>
            <td class="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400">
              <div class="flex items-center justify-center gap-1">
                <!-- View/Edit -->
                <button (click)="verQuote(quote)"
                  class="rounded-lg p-2 hover:bg-brand-50 hover:text-brand-600 dark:hover:bg-brand-900/20 dark:hover:text-brand-400 transition-colors"
                  title="Ver detalle">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z">
                    </path>
                  </svg>
                </button>

                <!-- Edit -->
                <button (click)="editarQuote(quote)"
                  *appHasPermission="'quotes:edit'"
                  class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors" title="Editar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                    </path>
                  </svg>
                </button>

                <!-- Publish (only for Borrador) -->
                @if (quote.statusName === 'Borrador') {
                <button (click)="publicarQuote(quote)"
                  *appHasPermission="'quotes:edit'"
                  class="rounded-lg p-2 hover:bg-teal-50 hover:text-teal-600 dark:hover:bg-teal-900/20 dark:hover:text-teal-400 transition-colors"
                  title="Publicar cotización">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </button>
                }

                <!-- Send by email (#28): opens the form with the send modal pre-opened -->
                <button (click)="enviarPorCorreo(quote)"
                  class="rounded-lg p-2 hover:bg-blue-light-50 hover:text-blue-light-600 dark:hover:bg-blue-light-900/20 dark:hover:text-blue-light-400 transition-colors"
                  title="Enviar por correo">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z">
                    </path>
                  </svg>
                </button>

                <!-- Download PDF -->
                <button (click)="descargarPdf(quote)"
                  class="rounded-lg p-2 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-white/[0.05] dark:hover:text-gray-300 transition-colors"
                  title="Descargar PDF">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                    </path>
                  </svg>
                </button>

                <!-- New Version -->
                <button (click)="nuevaVersion(quote)"
                  *appHasPermission="'quotes:create'"
                  class="rounded-lg p-2 hover:bg-purple-100 dark:hover:bg-purple-900/20 hover:text-purple-600 dark:hover:text-purple-400 transition-colors"
                  title="Nueva versión">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2">
                    </path>
                  </svg>
                </button>

                <!-- Duplicate -->
                <button (click)="duplicarQuote(quote)"
                  *appHasPermission="'quotes:create'"
                  class="rounded-lg p-2 hover:bg-blue-light-50 hover:text-blue-light-600 dark:hover:bg-blue-light-900/20 dark:hover:text-blue-light-400 transition-colors"
                  title="Duplicar cotización">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z">
                    </path>
                  </svg>
                </button>

                <!-- Delete -->
                <button (click)="eliminarQuote(quote)"
                  *appHasPermission="'quotes:delete'"
                  class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 dark:hover:bg-error-900/20 dark:hover:text-error-400 transition-colors"
                  title="Eliminar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                    </path>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    @if (globalTotalPages >= 1) {
    <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4">
      <div class="flex items-center justify-between gap-4 flex-wrap">
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-500 dark:text-gray-400">{{ globalTotalElements }} registros</span>
          <select [ngModel]="pageSize" (ngModelChange)="changePageSize($event)"
            class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                   focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            @for (opt of PAGE_SIZE_OPTIONS; track opt) {
              <option [value]="opt">{{ opt }}</option>
            }
          </select>
        </div>
        <div class="flex items-center gap-2">
          <button type="button" (click)="cambiarPagina(globalPage - 1)" [disabled]="!hasPrevPage"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                   hover:bg-gray-50 dark:hover:bg-gray-700
                   disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            Anterior
          </button>
          <div class="flex items-center gap-1.5">
            <span class="text-sm text-gray-500 dark:text-gray-400">Página</span>
            <select [ngModel]="pageDisplay" (ngModelChange)="cambiarPagina($event - 1)"
              class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                     bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                     focus:ring-2 focus:ring-brand-500 focus:border-transparent">
              @for (p of pagesArray; track p) {
                <option [value]="p">{{ p }}</option>
              }
            </select>
            <span class="text-sm text-gray-500 dark:text-gray-400">de {{ globalTotalPages }}</span>
          </div>
          <button type="button" (click)="cambiarPagina(globalPage + 1)" [disabled]="!hasNextPage"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                   hover:bg-gray-50 dark:hover:bg-gray-700
                   disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            Siguiente
          </button>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>

<!-- Modal: decidir aprobación pendiente desde la bandeja (RF-002) -->
<app-quote-approval-decision-modal
  [isOpen]="showDecisionModal"
  [approvalId]="decisionApprovalId"
  [decision]="decisionToMake"
  [quoteNumber]="decisionQuoteNumber"
  (closed)="cerrarDecision()"
  (decided)="onDecidido()">
</app-quote-approval-decision-modal>

<!-- El wizard de crear/editar cotización se monta a nivel de AppLayoutComponent (global) y se
     controla con QuoteFormModalService; al guardar emite saved$ y aquí refrescamos la lista. -->
